import {useEffect, useState} from 'react';
import classNames from 'classnames';
import brickScienceImage from '../../assets/reviews/brickscience-image.png';
import brickScienceLogo from '../../assets/reviews/brickscience-logo.jpg';
import colinAndSamirImage from '../../assets/reviews/colinandsamir-image.jpg';
import colinAndSamirLogo from '../../assets/reviews/colinandsamir-logo.png';
import girlWhoExcelImage from '../../assets/reviews/girlwhoexcel-image.png';
import girlWhoExcelLogo from '../../assets/reviews/girlwhoexcel-logo.png';
import itsBlumeImage from '../../assets/reviews/itsblume-image.jpg';
import itsBlumeLogo from '../../assets/reviews/itsblume-logo.png';
import longHairPrettyNailsImage from '../../assets/reviews/longhairprettynails-image.jpg';
import longHairPrettyNailsLogo from '../../assets/reviews/longhairprettynails-logo.png';

import {Container} from '../Container.client';
import SwiperClass, {Autoplay, Navigation} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

import {ReviewCard} from './ReviewCard.client';
import {useI18n} from '../../contexts/I18n.client';
import {interpolate} from 'utils/i18n';
import {useInView} from 'hooks/useInView';

import './Reviews.css';

export const Reviews = (props: {className?: string}) => {
  const {t} = useI18n();

  const {ref, inView} = useInView({
    threshold: 0.4,
  });

  const [swiper, setSwiper] = useState<SwiperClass>();

  useEffect(() => {
    if (swiper && inView) {
      swiper.autoplay.start();
    }
  }, [swiper, inView]);

  return (
    <Container
      className={classNames(
        'md:px-0',

        'text-4xl',
        'md:text-5xl',
        'lg:text-6xl',

        props.className,
      )}
      backgroundGradientStart="white"
      backgroundGradientEnd="light-green"
      ref={ref}
    >
      <h2
        className={classNames(
          'relative',
          'text-center',
          'm-auto',
          'text-center',
          'w-auto',
          'md:w-[80%]',

          'font-bold',
          'text-4xl',
          'leading-[40px]',
          'md:text-5xl',
          'md:leading-[52px]',
          'lg:text-6xl',
          'lg:leading-[66px]',
        )}
      >
        {interpolate(t('reviewsComponent.title'), {
          nowrap: (text) => <span className="whitespace-nowrap">{text}</span>,
          communitytype: () => (
            <span className="underline">
              {t('reviewsComponent.communityTypes.creators')}
            </span>
          ),
        })}
      </h2>

      <div className="mt-8">
        <div
          className={classNames(
            'flex',
            'md:w-[750px]',
            'min-[821px]:w-[810px]',
            'lg:w-[1030px]',
            'my-0',
            'mx-auto',
          )}
        >
          <Swiper
            className={classNames('!-mx-4', 'md:!mx-auto')}
            navigation
            modules={[Autoplay, Navigation]}
            centeredSlides
            loop
            autoplay={{
              delay: 4 * 1000,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1.2,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
            }}
            onSwiper={(swiper) => {
              setSwiper(swiper);
            }}
            onInit={(swiper) => {
              if (swiper.autoplay.running) {
                swiper.autoplay.stop();
              }
            }}
          >
            <SwiperSlide>
              <ReviewCard
                quote={t('reviewsComponent.reviews.colinandsamir')}
                name="Colin and Samir"
                title={t('reviewsComponent.titles.colinandsamir')}
                image={colinAndSamirImage}
                logo={colinAndSamirLogo}
                url="/colinandsamir"
              />
            </SwiperSlide>
            <SwiperSlide>
              <ReviewCard
                quote={t('reviewsComponent.reviews.longhairprettynails')}
                name="Evie"
                title={t('reviewsComponent.titles.longhairprettynails')}
                image={longHairPrettyNailsImage}
                logo={longHairPrettyNailsLogo}
                url="/longhairprettynails"
              />
            </SwiperSlide>
            <SwiperSlide>
              <ReviewCard
                quote={t('reviewsComponent.reviews.itsblume')}
                name="Blume"
                image={itsBlumeImage}
                logo={itsBlumeLogo}
                url="/itsblume_"
              />
            </SwiperSlide>
            <SwiperSlide>
              <ReviewCard
                quote={t('reviewsComponent.reviews.girlwhoexcel')}
                name="Sarah Johnson"
                title={t('reviewsComponent.titles.girlwhoexcel')}
                image={girlWhoExcelImage}
                logo={girlWhoExcelLogo}
                url="/girlwhoexcel"
              />
            </SwiperSlide>
            <SwiperSlide>
              <ReviewCard
                quote={t('reviewsComponent.reviews.brickscience')}
                name="Riley"
                title={t('reviewsComponent.titles.brickscience')}
                image={brickScienceImage}
                logo={brickScienceLogo}
                url="/brickscience"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </Container>
  );
};
